<!-- edit -->
<div class="d-flex justify-content-center">
  <a
    *ngIf="showEditButton"
    title="Edit"
    class="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
    (click)="onEditClicked()"
  >
    <span
      [inlineSVG]="'./assets/media/svg/icons/Communication/Write.svg'"
      cacheSVG="true"
      class="svg-icon svg-icon-md svg-icon-primary"
    >
    </span>
  </a>
  <!-- delete -->
  <a
    *ngIf="showDeleteButton"
    title="Delete"
    class="btn btn-icon btn-light btn-hover-danger btn-sm"
    (click)="onDeleteClicked()"
  >
    <span
      [inlineSVG]="'./assets/media/svg/icons/General/Trash.svg'"
      cacheSVG="true"
      class="svg-icon svg-icon-md svg-icon-danger"
    >
    </span>
  </a>
  <a
    *ngIf="showHideButton"
    title="Hide"
    class="btn btn-icon btn-light btn-hover-warning btn-sm mx-3"
    (click)="onHideClicked()"
  >
    <span
      [inlineSVG]="'./assets/media/svg/icons/Communication/Archive.svg'"
      cacheSVG="true"
      class="svg-icon svg-icon-md svg-icon-warning"
    >
    </span>
  </a>
  <a
    *ngIf="showUnhideButton"
    title="Unhide"
    class="btn btn-icon btn-light btn-hover-warning btn-sm mx-3"
    (click)="onUnhideClicked()"
  >
    <span
      [inlineSVG]="'./assets/media/svg/icons/Communication/Archive.svg'"
      cacheSVG="true"
      class="svg-icon svg-icon-md svg-icon-warning"
    >
    </span>
  </a>

  <a
    *ngIf="showDuplicateButton"
    title="Duplicate"
    class="btn btn-icon btn-light btn-hover-info btn-sm mx-3"
    (click)="onDuplicateClicked()"
  >
    <span
      [inlineSVG]="'./assets/media/svg/icons/General/Duplicate.svg'"
      cacheSVG="true"
      class="svg-icon svg-icon-md svg-icon-info"
    >
    </span>
  </a>

  <a
    *ngIf="showSetGiftsButton"
    title="Set Gifts"
    class="btn btn-icon btn-light btn-hover-info btn-sm mx-3"
    (click)="onSetGiftsClicked()"
  >
    <span
      [inlineSVG]="'./assets/media/svg/icons/Shopping/Gift.svg'"
      cacheSVG="true"
      class="svg-icon svg-icon-md svg-icon-info"
    >
    </span>
  </a>

  <a
    *ngIf="showViewButton"
    title="View"
    class="btn btn-icon btn-light btn-hover-warning mx-3 btn-sm"
    (click)="onViewClicked()"
  >
    <i class="fas fa-eye"></i>
  </a>
</div>
